import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { partnerHomeFor, syncAccountPartner } from '../config/partnerThemes';

// A single-coach partner keeps its people on one coach. Two jobs:
//  1. Apply that rule on every page change inside the app.
//  2. Learn from the server whether this account belongs to a pilot. Sign-in
//     and registration ask before they move on; this covers someone who is
//     already signed in and opens the site in a new tab. If the answer arrives
//     after the page has drawn, reload once so everything shows the pilot.
let checkedToken;

const PartnerHomeGuard = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    let token = null;
    try { token = localStorage.getItem('token'); } catch (e) { /* storage blocked */ }
    if (token === checkedToken) return;
    checkedToken = token;
    syncAccountPartner().then((changed) => {
      if (!changed) return;
      const here = window.location.pathname;
      window.location.replace(partnerHomeFor(here) || (here + window.location.search));
    });
  }, [pathname]);

  const target = partnerHomeFor(pathname);
  return target ? <Navigate to={target} replace /> : null;
};

export default PartnerHomeGuard;
